export default __webpack_public_path__ + "static/media/V3-2023T4T-C5TrainerCourseWorkbook.118e9562.pdf";